import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const retrieveDifferences = api(
    ({
        regimeId,
        skip,
        take,
        sort,
        addedSkip = skip,
        addedTake = take,
        removedSkip = skip,
        removedTake = take,
        changedSkip = skip,
        changedTake = take,
    }) =>
        query(
            gql`
                query RetrieveDifferences(
                    $regimeId: String!
                    $addedSkip: Int
                    $sort: [String]
                    $addedTake: Int
                    $removedSkip: Int
                    $removedTake: Int
                    $changedSkip: Int
                    $changedTake: Int
                ) {
                    regimeDifferences(regimeId: $regimeId, sort: $sort) {
                        id
                        differences {
                            id
                            total
                            currentMinutes
                            formerMinutes
                            added {
                                id
                                minutes
                                summarise(by: ["classification"]) {
                                    summary(take: 1000) {
                                        key
                                        value
                                        count
                                    }
                                }
                                tasks {
                                    id
                                    total
                                    items(skip: $addedSkip, take: $addedTake) {
                                        id
                                        taskId
                                        where
                                        classification
                                        code
                                        scheduleTitle
                                        schedule {
                                            _id
                                            id
                                            code
                                            version
                                        }
                                        title
                                        tag
                                        assetIndex
                                        assetId

                                        frequency {
                                            label
                                            period
                                            interval
                                        }
                                        skill
                                        minutes
                                        count
                                        annualMinutes
                                    }
                                }
                            }
                            removed {
                                minutes
                                id
                                summarise(by: ["classification"]) {
                                    summary(take: 1000) {
                                        key
                                        value
                                        count
                                    }
                                }
                                tasks {
                                    id
                                    total
                                    items(skip: $removedSkip, take: $removedTake) {
                                        id
                                        taskId
                                        where
                                        classification
                                        code
                                        scheduleTitle
                                        title
                                        tag
                                        assetIndex
                                        assetId
                                        schedule {
                                            _id
                                            id
                                            code

                                            version
                                        }

                                        frequency {
                                            label
                                            period
                                            interval
                                        }
                                        skill
                                        minutes
                                        count
                                        annualMinutes
                                    }
                                }
                            }
                            changed {
                                minutes
                                id
                                summarise(by: ["classification"]) {
                                    summary(take: 1000) {
                                        key
                                        value
                                        count
                                    }
                                }
                                tasks {
                                    id
                                    total
                                    items(skip: $changedSkip, take: $changedTake) {
                                        id
                                        taskId
                                        where
                                        classification
                                        code
                                        scheduleTitle
                                        title
                                        tag
                                        assetIndex
                                        assetId
                                        schedule {
                                            _id
                                            id
                                            code
                                            version
                                        }
                                        frequency {
                                            label
                                            period
                                            interval
                                        }
                                        skill
                                        minutes
                                        count
                                        annualMinutes
                                        changeInMinutes
                                    }
                                }
                            }
                        }
                    }
                }
            `,
            { regimeId, addedSkip, addedTake, changedSkip, changedTake, removedSkip, removedTake, sort },
            {
                returns: "regimeDifferences.differences",
            }
        )
)
